// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'
import { initialize } from 'redux-form'
import { fetchAndAddRadioSettings } from 'redux/modules/domain'
import setNewRadioInitialValues from './setNewRadioInitialValues'
import formatRadioDataForDetails from './formatRadioDataForDetails'
import { fetchRadioById } from 'helpers/api'
import { cleanAllComments } from 'redux/modules/databaseDetails'
import formatModulationsForRadioDetails from './formatModulationsForRadioDetails'

const setRadioDetails = radioIdStr => async (dispatch, getState) => {
  const {
    domain,
    user,
  } = getState()

  let initialRadioValues

  const entityDetails = {
    comments: [],
    dbSet: 'radio',
    entityId: null,
    error: '',
    initialValues: {
      // we will track if we've made updates to the modulation values stored here
      // so that the radio details form can treat modified modulation data
      // as 'dirty' for the radio details form.
      containsModulationUpdate: false,
      radioModulations: [],
    },
    isNewEntity: true,
  }

  // if there are no radio settings loaded in redux, grab em before going further
  if (!domain.getIn(['radioSettings', 'curveTypeCodes']).size) {
    await dispatch(fetchAndAddRadioSettings())
  }

  try {
    // if it's called 'new-radio', there's no reason to hit the API.
    // but we want to treat it the same as an API error
    // because we'll show new form values for both scenarios.
    if (radioIdStr === 'new-radio') {
      const err = {}
      throw err
    }

    // try to get the existing entity from the API. (based on the url as entity id)
    const { entity } = await fetchRadioById(radioIdStr)
    const entityId = entity.radioId

    initialRadioValues = formatRadioDataForDetails(entity)

    entityDetails.comments = cleanAllComments(entity.comments, 'radioCommentId')
    entityDetails.entityId = entityId

    // TODO - should the modulations be stored in the parent component's state instead of redux?
    entityDetails.initialValues.radioModulations = formatModulationsForRadioDetails(entity.radioModulations)
    entityDetails.isNewEntity = false
    entityDetails.sourceForm = `radio-details-${entityId}`
  } catch (err) {
    // if err.message then a proper error was thrown
    // if we're on 'new-radio', there will be no message so don't log it. we meant to be here
    if (err.message) {
      console.warn(err)
    }

    // non-database users cannot create new radio.
    // after here, all we're doing is getting ready to set up a brand new entity
    // so if the user does not have db access, GET EM OUTTA HERE!
    if (!user.getIn(['permissions', 'database'])) {
      return dispatch(push('/database-management/radio'))
    }

    const {
      error,
      initialValues,
    } = await setNewRadioInitialValues()

    initialRadioValues = initialValues

    entityDetails.error = err.message || error
    entityDetails.sourceForm = `radio-details-${radioIdStr}`
  }

  await dispatch(initialize(entityDetails.sourceForm, initialRadioValues))

  return entityDetails
}

export default setRadioDetails
